import { Suspense, type ReactElement } from 'react';
import { useRemoteComponent } from 'zf-web-components';
import { customize } from '@customize';
import { useApp } from '../../hooks';
import { getRemoteUrl } from './util';

export function SearchCenter(): ReactElement {
  const { app } = useApp();
  const hidden = customize.invoke('heytea.header.hideSearchCenter') === true;
  const remote = getRemoteUrl(app);
  const { Component: LazySearchCenter } = useRemoteComponent(remote as string, 'SearchCenter');

  if (remote == null || hidden) {
    return <></>;
  }


  return (
    <Suspense fallback={<></>}>
      {LazySearchCenter != null && <LazySearchCenter />}
    </Suspense>
  );
}
